import { createAction } from 'redux-actions';

export const clearDownloadRequests = createAction('CLEAR_DOWNLOAD_REQUESTS');

export const setDownloadRequestsQuery = createAction(
  'SET_DOWNLOAD_REQUESTS_QUERY'
);

export const clearDownloadRequestsSearchOptions = createAction(
  'CLEAR_DOWNLOAD_REQUESTS_SEARCH_OPTIONS'
);

export const downloadRequestsOnChangePage = createAction(
  'DOWNLOAD_REQUESTS_ON_CHANGE_PAGE'
);

export const resetDownloadRequestDeleted = createAction(
  'RESET_DOWNLOAD_REQUEST_DELETED'
);
